<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" class="button add" @click="clear();Edit='add';">新增</button>
			</p>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>课程名称</th>
						<th>课程说明</th>
						<th>修改</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in Subjects">
						<td>
							{{index+1}}
						</td>
						<td>
							{{i.SubjectName}}
						</td>
						<td>
							{{i.SubjectDesc}}
						</td>
						<td>
							<button type="button" @click="update(i)" title="点击修改" class="button">修改</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>


		<div class="booksMangement" v-show="Edit!=''">
			<div v-show="Edit!=''">
				<div>
					<span class="red">*</span>课程名称:
				</div>
				<div>
					<input type="text" v-model="SubjectName" placeholder="请输入课程名称" required="required" />
					<span class="err">{{SubjectName.trim()!=''? ' ':'×'}}</span>
				</div>
				<div>
					<span class="red">*</span>课程说明:
				</div>
				<div>

					<input type="text" v-model="SubjectDesc" required="required" placeholder="请输入课程说明" />

					<span class="err"> </span>
				</div>


				<div>
				</div>
				<div>

					<button class="button" :class="{'disabled':SubjectName.trim()==''}"
						:disabled="SubjectName.trim()==''" @click="edit">{{ SubjectID==0?'新增':'修改'}}</button>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<button class="button" @click="Edit=''">取消</button>
				</div>
			</div>
		</div>
		<div class="edit" v-if="Edit=='code'" @click="hideCode">
			<img :src="CustomerQRcode" />
		</div>
	</div>

</template>

<script>
	import j from './index.js'
	export default j
</script>

<style>
</style>
